import React from "react";
import AspectBanner from "../../../Common/AspectBanner";
import { isAdani } from "../../../../utils/isClient";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Card = function Card(_ref) {
  var title = _ref.title,
    img = _ref.img,
    fullHeight = _ref.fullHeight,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AspectBanner, {
      image: img,
      onClick: onClick
    })
  });
};
var DealsCategory = function DealsCategory(_ref2) {
  var className = _ref2.className,
    isRewards = _ref2.isRewards,
    _ref2$router = _ref2.router,
    router = _ref2$router === void 0 ? {} : _ref2$router,
    config = _ref2.config;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var handleBannerClick = function handleBannerClick(path, categoryName) {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("DealBannerClicked", {
      categoryName: categoryName
    });
    history.push("/dealListing".concat(path));
  };
  var isAdaniClient = isAdani(config);
  return /*#__PURE__*/_jsxs("section", {
    className: "w-full mx-auto py-10",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "w-full grid grid-cols-2 gap-4 lg:hidden",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "grid grid-rows-2 gap-4",
        children: [/*#__PURE__*/_jsx(Card, {
          title: "Home Services",
          img: "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/SM/HOME_SERVICES.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=2&categoryName=Home Services", "Home Services");
          }
        }), /*#__PURE__*/_jsx(Card, {
          title: "Lifestyle",
          img: "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/SM/LIFESTYLE.png",
          fullHeight: true,
          onClick: function onClick() {
            return handleBannerClick("?categoryID=1&categoryName=Lifestyle", "Lifestyle");
          }
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "grid grid-rows-2 gap-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "grid grid-rows-2 gap-3",
          children: [/*#__PURE__*/_jsx(Card, {
            title: "Home Furnishing",
            img: "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/SM/HOME_FURNISHING.png",
            onClick: function onClick() {
              return handleBannerClick("?categoryID=10&categoryName=Home Furnishing", "Home Furnishing");
            }
          }), /*#__PURE__*/_jsx(Card, {
            title: "Finance",
            img: "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/SM/FINANCE.png",
            onClick: function onClick() {
              return handleBannerClick("?categoryID=3&categoryName=Finance", "Finance");
            }
          })]
        }), /*#__PURE__*/_jsx(Card, {
          title: "Electronics",
          img: "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/SM/ELECTRONICS.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=10&categoryName=Electronics", "Electronics");
          }
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "hidden lg:grid gap-6",
      style: {
        gridTemplateColumns: "calc(35% - 1rem) calc(30% - 1rem) calc(35% - 1rem)"
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "grid grid-rows-2 gap-6",
        children: [/*#__PURE__*/_jsx(Card, {
          title: "Home Services",
          img: isAdaniClient ? 'https://cdn.loyalie.in/Concierge_Banner/Web/Home-services.png' : "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/LG/HOME_SERVICES.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=2&categoryName=Home Services", "Home Services");
          }
        }), /*#__PURE__*/_jsx(Card, {
          title: "Home Furnishing",
          img: isAdaniClient ? "https://cdn.loyalie.in/Concierge_Banner/Web/Home-furnishing.png" : "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/LG/HOME_FURNISHING.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=10&categoryName=Home Furnishing", "Home Furnishing");
          }
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "h-full ",
        children: /*#__PURE__*/_jsx(Card, {
          title: "Lifestyle",
          img: isAdaniClient ? "https://cdn.loyalie.in/Concierge_Banner/Web/Lifestyle.png" : "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/LG/LIFESTYLE.png",
          fullHeight: true,
          onClick: function onClick() {
            return handleBannerClick("?categoryID=1&categoryName=Lifestyle", "Lifestyle");
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "grid grid-rows-2 gap-6",
        children: [/*#__PURE__*/_jsx(Card, {
          title: "Electronics",
          img: isAdaniClient ? "https://cdn.loyalie.in/Concierge_Banner/Web/Electronics.png" : "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/LG/ELECTRONICS.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=10&categoryName=Electronics", "Electronics");
          }
        }), /*#__PURE__*/_jsx(Card, {
          title: "Finance",
          img: isAdaniClient ? "https://cdn.loyalie.in/Concierge_Banner/Web/Finance.png" : "https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/Concierge/LG/FINANCE.png",
          onClick: function onClick() {
            return handleBannerClick("?categoryID=3&categoryName=Finance", "Finance");
          }
        })]
      })]
    })]
  })
  // <div
  //     className={`grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 cursor-pointer ${className}`}
  // >
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?tagID=38&tagName=Furniture',
  //                 'Furniture'
  //             )
  //         }
  //         className={`row-span-2 w-full h-full ${
  //             isRewards ? 'overflow-hidden rounded-xl' : ''
  //         } `}
  //     >
  //         <img
  //             className={`w-full mx-auto rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720705877913_Furniture"
  //             alt="banner"
  //         />
  //     </div>

  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?tagID=43&tagName=Home Automation',
  //                 'Home Automation'
  //             )
  //         }
  //         className={`w-full h-full  ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         }`}
  //     >
  //         <img
  //             className={`w-full rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706018814_Home%20Automation"
  //             alt="wallpaper"
  //         />
  //     </div>
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?tagID=39&tagName=Electronics',
  //                 'Electronics'
  //             )
  //         }
  //         className={`w-full h-full ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         }`}
  //     >
  //         <img
  //             className={`w-full rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706216336_Electronics"
  //             alt="wallpaper"
  //         />
  //     </div>
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?categoryID=1&categoryName=Member Benefits',
  //                 'Member Benefits'
  //             )
  //         }
  //         className={`hidden lg:block row-span-2 w-full h-full ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         } `}
  //     >
  //         <img
  //             className={`w-full mx-auto rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706421770_Lifestyle"
  //             alt="banner"
  //         />
  //     </div>
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?categoryID=3&categoryName=Home Financing Deals',
  //                 'Home Financing Deals'
  //             )
  //         }
  //         className={`w-full h-full ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         }`}
  //     >
  //         <img
  //             className={`w-full rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706509111_HomeLoan"
  //             alt="wallpaper"
  //         />
  //     </div>
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?categoryID=1&categoryName=Member Benefits',
  //                 'Member Benefits'
  //             )
  //         }
  //         className={`lg:hidden row-span-2 w-full h-full ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         }`}
  //     >
  //         <img
  //             className={`w-full mx-auto rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706421770_Lifestyle"
  //             alt="banner"
  //         />
  //     </div>
  //     <div
  //         onClick={() =>
  //             handleBannerClick(
  //                 '?tagID=42&tagName=Sleep Products',
  //                 'Sleep Products'
  //             )
  //         }
  //         className={`w-full h-full ${
  //             isRewards ? 'overflow-hidden  rounded-xl' : ''
  //         }`}
  //     >
  //         <img
  //             className={`w-full rounded-xl ${
  //                 isRewards
  //                     ? 'object-cover transition-transform duration-300 ease-in-out transform hover:scale-110'
  //                     : ''
  //             }`}
  //             src="https://cdn.loyalie.in/1720706565280_Sleep%20Products"
  //             alt="wallpaper"
  //         />
  //     </div>
  // </div>
;
};
export default DealsCategory;